import { useMutation } from "@tanstack/react-query";
import { bulkAdminBlueprintActivitiesOperations } from "PFCore/services/admin/engagement_blueprints";
import { ActivityOperation } from "PFCore/services/bulk_operations";
import { Id } from "PFCore/types";

import { mutationKeys } from "./mutation_keys";

export const useAdminEngagementBlueprintBulkActivitiesOperations = () =>
  useMutation({
    mutationKey: mutationKeys.bulkAdminBlueprintActivitiesOperations(),
    mutationFn: ({ id, bulkOperations }: { id: Id; bulkOperations: ActivityOperation[] }) =>
      bulkAdminBlueprintActivitiesOperations(id, bulkOperations)
  });
